import React from 'react';
import { useSelector } from 'react-redux';
import { localeMoment } from '../../../../utils/moment';
import { getTranslation } from '../../../../utils/translation';
import Status from '../../../shared/Status/Status';
import { INCREASE_REPORT_STATUSES } from '../../../../constants/defaultValues';

const Table = () => {
    const data = useSelector(state => state.increaseReports.reports);
    const locale = useSelector(state => state.settings.locale);

    const getStatusTheme = statusId => {
        switch (statusId) {
            case 1:
                return 'neutral';
            case 2:
            case 4:
            case 5:
            case 6:
                return 'success';
            case 3:
                return 'danger';
            default:
                return 'neutral';
        }
    };

    const getStatusTitle = statusId => INCREASE_REPORT_STATUSES.find(s => s.id === statusId)?.label;

    return data.length > 0 ? (
        <table className={'point-table point-table--credit'}>
            <thead>
                <tr align='center'>
                    <th>{getTranslation('increaseReportsTableNoColumn')}</th>
                    <th>{getTranslation('increaseReportsStatusColumn')}</th>
                    <th>{getTranslation('increaseReportsAmountColumn')}</th>
                    <th>{getTranslation('increaseReportsRequestDateColumn')}</th>
                    <th>{getTranslation('increaseReportsProcessingDateColumn')}</th>
                </tr>
            </thead>
            <tbody>
                {data.map((transaction, index) => (
                    <tr key={transaction.id} align='center'>
                        <td className='td-number'>{index + 1}</td>
                        <td>
                            <Status
                                status={getStatusTheme(transaction.status)}
                                title={getStatusTitle(transaction.status)}
                            />
                        </td>
                        <td>{transaction.amount.toFixed(2)} AZN</td>
                        <td>
                            {transaction.created
                                ? localeMoment(locale)(transaction.created).format(
                                      'DD.MM.YYYY / HH:mm:ss'
                                  )
                                : getTranslation('notAvailableDate')}
                        </td>
                        <td>
                            {transaction.updated
                                ? localeMoment(locale)(transaction.updated).format(
                                      'DD.MM.YYYY / HH:mm:ss'
                                  )
                                : getTranslation('notAvailableDate')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    ) : null;
};

export default Table;
